import { createFileRoute } from "@tanstack/react-router";

import { handleAuthCallback } from "@onesolution/serverFn";

export const Route = createFileRoute("/(auth)/loginCallback")({
	beforeLoad: async () => {
		await handleAuthCallback();
	},
});
